import {
  GET_ALL_QR,
  CLEAR_ALL_QR,
  QR_LOADING_END,
  QR_LOADING_START,
  //   SET_ERROR,
} from "./types";
import QRServices from "../../services/qr.services";
import { openNotification } from "../Notification/notifications.action";

export const getAllQrCodes = (pageSize, currentPage) => (dispatch) => {
  dispatch({ type: QR_LOADING_START });
  return QRServices.getAllQr(pageSize, currentPage)
    .then(({ data: { data } }) => {
      dispatch({ type: GET_ALL_QR, payload: data });
      dispatch({ type: QR_LOADING_END });
    })
    .catch((err) => {
      const error = err.response.data.data || "Something Hapopened";
      openNotification({
        message: "Error",
        description: error,
        icon: "error",
      });
      dispatch({ type: QR_LOADING_END });
    });
};

export const getAdminQrCode = (pageSize, currentPage, id) => (dispatch) => {
  return QRServices.getAdminQrCodes(pageSize, currentPage, id)
    .then(({ data: { data } }) => {
      return data;
    })
    .catch((err) => {
      const error =
        err?.response?.message ||
        err?.response?.statusText ||
        "Something Happened";
      openNotification({
        message: "Error",
        description: error,
        icon: "error",
      });
    });
};

export const clearQR = () => (dispatch) => {
  dispatch({ type: CLEAR_ALL_QR });
};

export const blockQrCode = (qrId, pageSize, currentPage) => (dispatch) => {
  return QRServices.blockQrCode(qrId)
    .then(
      ({
        data: {
          data: { block },
        },
      }) => {
        openNotification({
          message: "Success",
          description: block ? "QR Blocked" : "QR Unblocked",
          icon: "success",
        });
        dispatch(getAllQrCodes(pageSize, currentPage));
      }
    )
    .catch((err) => {
      const error = err?.response?.message || err?.response?.statusText;
      openNotification({
        message: "Error",
        description: error,
        icon: "error",
      });
    });
};
export const removeQr = (qrId, pageSize, currentPage) => (dispatch) => {
  return QRServices.removeQrCode(qrId)
    .then((data) => {
      openNotification({
        message: "Success",
        description: "QR Removed",
        icon: "success",
      });
      dispatch(getAllQrCodes(pageSize, currentPage));
    })
    .catch((err) => {
      const error = err?.response?.message || err?.response?.statusText;
      openNotification({
        message: "Error",
        description: error,
        icon: "error",
      });
    });
};
